
//Import React Hooks
import { useEffect, useState } from 'react'

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

// API fetch
import axios from "axios";
import { baseURL } from '../../config/api-config.js';

//MUI :
import Button from '@mui/material/Button';

// Draft Page to add bunch of creneaux in DB

function Admin() { // full page as component imported in router

    const [creneauxAjoutes, setCreneauxAjoutes] = useState([]);

    //// -- Parameters !!
    let horaireList = [9.5, 10, 12, 12.5, 14.5, 15]; // list of creneaux horaires (start)
    let duree = 2; // duration in hours
    let nb_moniteurs = 4;
    let datedeb = "2024-04-01"; // start of the period we add creneaux
    let datefin = "2024-11-30"; // end of the period we add creneaux
    //// -- End of parameters

    async function creerCreneaux() {
        let newCreneaux = await initCreneauxPeriod();
        setCreneauxAjoutes(newCreneaux[0]);

    }



    async function initCreneauxPeriod() {

        let problemes = [];
        let allCreneaux = [];
        let nbJours = dayjs(datefin).diff(datedeb, 'day') // how many days to create?

        for (let i = 0; i <= nbJours; i++) { // for each day
            let jourCourant = dayjs(datedeb).add(i, "day").format("YYYY-MM-DD"); // set current day

            horaireList.map((horaire) => { // for each new creneau


                axios.post(`${baseURL}/creneau/init-period`, { // request to backend
                    date: jourCourant,
                    horaire: horaire,
                    duree: duree,
                    qte_moniteurs: nb_moniteurs
                })
                    .then((response) => {
                        if (response.status === 201) { // insertion in DB went good
                            allCreneaux.push(response.data);
                        }
                        else { // any problem?
                            problemes.push(response.data); // we fill the problemes array
                        }
                    })
                    .catch(error => {
                        console.error(error);
                        problemes.push(error);
                    })
            });// end of map
        } // end for

        return [allCreneaux, problemes];


    }


    return (
        <div className="admin-creneaux">
            <p>{`du ${datedeb} au ${datefin}`}</p>
            <p>{`horaires : ${horaireList.join("-")}`}</p>
            <p>{`duree:${duree}`}</p>
            <p>{`nb monos:${nb_moniteurs}`}</p>
            <Button onClick={async () => await creerCreneaux()}>Créer les créneaux</Button>
            <div>
                {console.log(creneauxAjoutes)}
                {creneauxAjoutes.map((creneau) => (
                    <p key={creneau.id_creneau}>{creneau.data.id_creneau}</p>

                ))}
            </div>
        </div>
    );
}

export default Admin;